import React from 'react';

interface ReceivablesTileProps {
    testId: string;
    label: string;
    value: string;
    /** Read out with the value, never drawn. */
    note?: string;
}

/** One column of a `ReceivablesRow`: label on top and the figure beneath it. */
export const ReceivablesTile: React.FC<ReceivablesTileProps> = ({ testId, label, value, note }) => (
    <div data-testid={testId} className="flex h-[50px] min-w-[130px] flex-col justify-center gap-0.5 rounded-md bg-surface-secondary px-s">
        <dt className="whitespace-nowrap text-xs font-semibold text-content-tertiary">{label}</dt>
        <dd className="text-xs font-bold tabular-nums text-content">
            {value}
            {note && <span className="sr-only"> {note}</span>}
        </dd>
    </div>
);
